import { LocalStorageService } from '../../configuration/local-storage/local-storage.service';

/**
 * Người xem mà máy chủ quảng cáo thấy: máy chủ lấy người xem từ token đăng nhập, nên khoá đổi khi có hay mất token
 * (khách đăng nhập không tải lại trang). Không dựa vào hồ sơ trong Redux vì hồ sơ đến sau token, dùng nó sẽ serve hai lần
 * mỗi lần mở trang. Đăng xuất luôn tải lại trang nên không có chuyện đổi thẳng từ tài khoản này sang tài khoản khác.
 */
export const adViewerKey = (): 'user' | 'guest' => {
  try {
    return LocalStorageService.getItem('accessToken') ? 'user' : 'guest';
  } catch {
    return 'guest';
  }
};
